import React from "react";
import TextEditor from "../../themed/text-editor";

import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import Button from "../../themed/button";

const HardnessRemarkSchema = z.object({
    remark: z.string().min(3, 'Remark must be at least 3 characters'),
});

type HardnessRemark = z.infer<typeof HardnessRemarkSchema>;

type Props = {
    initialRemark: string;
    onSave: (remark: string) => void;
}

const HardnessRemarkForm: React.FC<Props>= ({ initialRemark, onSave }) => {
    const form = useForm<HardnessRemark>({
        resolver: zodResolver(HardnessRemarkSchema),
        mode: 'onChange',
        defaultValues: { remark: initialRemark },
    });
    
    return ( 
        <form onSubmit={form.handleSubmit((data) => onSave(data.remark))}>
            <Controller
                control={form.control}
                name="remark"
                render={({ field }) => (
                    <TextEditor
                        name={field.name}
                        label="Remark"
                        error={form.formState.errors.remark ? form.formState.errors.remark.message : ''}
                        value={field.value}
                        placeholder="Enter Remark"
                        onChange={field.onChange} 
                    />
                )}
            />
            
            <div className="d-flex justify-content-end">
                <Button
                    type="submit"
                    disabled={!form.formState.isValid}
                    label={form.formState.isSubmitting ? "Saving..." : "Save"}
                />
            </div>
        </form>
     );
}
 
export default HardnessRemarkForm;